// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"568":"user","864":"admin"}[chunkId] || chunkId) + "." + {"568":"e2a79abb","864":"aeffb775","976":"64f92a41"}[chunkId] + ".bundle.js";
};